import React, { Component } from "react";
import fetch from "node-fetch";

import { createHttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import styled from "styled-components";

import { BrowserRouter } from "react-router-dom";

import { ApolloProvider } from "react-apollo";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import config from "../../config";
import configureStore from "../../configureStore";

import Router from "../Router/Router";
import RouteChange from "../HOC/RouteChange";
import Loading from "../Loading/Loading";

import "./app.css";
import "sweetalert/dist/sweetalert.css";

const { store, persistor } = configureStore();

const link = createHttpLink({ uri: `${config.API_URL}/graphql`, fetch });

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: link,
  ssrMode: true
});

const AppContainer = styled.div`
  display: ${props => (props.visible ? "block" : "none")};
`;

class App extends Component {
  state = {
    visible: false
  };

  componentDidMount() {
    if (window.VRT && window.location.href.indexOf("share") === -1) {
      new window.VRT.cookieConsent();
    }
    this.setState({ visible: true });
  }

  render() {
    const { visible } = this.state;

    return (
      <AppContainer visible={visible}>
        <Provider store={store}>
          <ApolloProvider client={client}>
            <PersistGate
              loading={<Loading text="Gate" />}
              persistor={persistor}
            >
              <BrowserRouter>
                <RouteChange>
                  <Router />
                </RouteChange>
              </BrowserRouter>
            </PersistGate>
          </ApolloProvider>
        </Provider>
      </AppContainer>
    );
  }
}

export { client, link, config };
export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js